import React, { useState, useEffect, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHeaderForManufacturer } from './tableHeaderForManufacturer';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  handleQuarterFormate,
  checkQuarterValidation,
  isNumeric,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  defaultPlanType,
  allTemplateTypeCd,
  defaultSelectBy,
  selectByList,
  coverTemplate,
  InvNumSelectBy,
  somethingWentWrong,
} from './ConstantData';
import {
  TEMPLATE_NAME_REQUIRED_ERROR,
  ENTER_NUMERIC_ONLY_ERROR,
  INVALID_INVOICE_NUM,
  QUARTER_VALUE_REQUIRED,
  REBATE_PROGRAM_REQUIRED,
  QUARTER_FORMAT_ERROR_UC,
  FAIL_PROCESSING_REQUEST,
  MNFC_NDC_ERROR_MSG,
  NO_DATA_FOUND_ERROR,
  INVALID_INVOICE_ERR
} from '../../../../SharedModules/Errors/constantMessageData';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  getTemplateTypeList,
  getRebateProgrameList,
  getManufacturerData,
  getQuarterValue,
  dispatchRequestData,
  dispatchErrorMsg,
  getTemplateNameList,
  dispatchTemplateNameList,
  setCreateTemplateExtraState,
  updateCreateLetterDetail,
  updateCreateLetterSaveApi,
  fetchCreateLetterDetailData,
  updateCreateLetterDetailData,
  updateInvoiceDetailsByInvoiceNum,
  getInvoiceDetailsByInvoiceNum,
} from '../store/action';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';
import { getTempTableData } from '../../../Display/Letter/store/Actions';

function CreateLetter(props) {
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const requestData = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.requestScreenData
  );
  const userDefaults = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const extraState = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.extraState
  );
  const errorMessages = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.errorMessages
  );
  const searchErrorMessages = useSelector(
    (state) => state.sharedState.CreateLetterReducer.errorMessages.searchPage
  );
  const templateNameList = useSelector(
    (state) => state.sharedState.CreateLetterReducer?.templateName
  );
  const getQuarterDataValue = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.quarter
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.planType
  );
  // const getRebateProgramList = useSelector(
  //   (state) => state?.sharedState?.CreateLetterReducer?.rebateProgram
  // );
  const ManufacturerDataList = useSelector(
    (state) => state.sharedState?.CreateLetterReducer?.manufacturer
  );
  const createLetterDetail = useSelector(
    (state) => state?.sharedState?.CreateLetterReducer?.createLetterDetail
  );
  const templateTypeList = useSelector(
    (state) => state.sharedState.CreateLetterReducer?.templateType
  );
  const fullScreenView = useSelector(
    (state) =>
      state.sharedState.CreateLetterReducer.extraState?.fullScreenView?.mfgTable
  );
  const createLetterActive = useSelector(
    (state) =>
      state.sharedState.CreateLetterReducer.extraState.createLetterActive
  );
  const getInvDetail = useSelector(
    (state) => state.sharedState.CreateLetterReducer.getInvDetail
  );
  const disabledBtn = useSelector(
    (state) => state.sharedState.CreateLetterReducer.extraState.disabledBtn
  );

  const dispatch = useDispatch();
  const setRequestData = (value) => dispatch(dispatchRequestData(value));
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  const [loading, setLoading] = React.useState(true);
  const [rebateProList, setRebateProList] = React.useState([]);
  const [filterValue, setSetFilterValue] = React.useState({
    selectTypeCd: defaultSelectBy,
    planTypeCd: 'FD',
    templateTypeCd: '',
    quarterValue: '',
    rebateProgramCd: '-1',
    templateNameCd: null,
    templateVersion: -1,
    templateName: '',
    selectedTemplate: {},
  });

  // This run when state value changed and save in redux
  const setStateChange = (val) => {
    dispatch(
      setCreateTemplateExtraState({
        ...extraState,
        ...val,
      })
    );
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    dispatch(
      dispatchErrorMsg({
        ...errorMessages,
        ...val,
      })
    );
  };

  // Tab highlighter POC
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/createLetter') {
          if (!_.isEmpty(searchErrorMessages)) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [searchErrorMessages]);

  // fetch rebate program
  // const fetchRebateProgram = (planTypeCd) => {
  //   if (planTypeCd) {
  //     setLoading(true);
  //     dispatch(getRebateProgrameList(planTypeCd));
  //   }
  // };

  React.useEffect(() => {
    if (filterValue?.planTypeCd) {
      getRebateProgrameList(filterValue?.planTypeCd).then((res) =>
        setRebateProList(res)
      );
    }
  }, [filterValue?.planTypeCd]);

  // This Run when isRefresh is true
  React.useEffect(() => {
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter((x) => x.navTo === '/createLetter' && x.isRefresh)
        .length > 0
    ) {
      setLoading(true);
      dispatch(getQuarterValue());
      dispatch(
        getTemplateTypeList({
          codeDomainList: ['TEMPLATE_TYPE_CD', 'PLAN_TYPE_CD'],
        })
      );
      const searchVal = {};
      searchVal.selectTypeCd = defaultSelectBy;
      searchVal.templateTypeCd = allTemplateTypeCd;
      searchVal.templateNameCd = '-1';
      searchVal.planTypeCd = defaultPlanType;
      searchVal.rebateProgramCd = '-1';
      searchVal.selectedTemplate = {};
      searchVal.quarterValue = '';
      if (userDefaults && !_.isEmpty(userDefaults)) {
        searchVal.selectTypeCd = userDefaults.defInvoiceSelectModeCd;
        searchVal.planTypeCd = userDefaults.planTypeCd
          ? userDefaults.planTypeCd
          : defaultPlanType;
        searchVal.rebateProgramCd = userDefaults.rebateProgramCd
          ? userDefaults.rebateProgramCd
          : '-1';
      }
      // fetchRebateProgram(searchVal.planTypeCd);
      setRequestData({ ...searchVal });
      setErrorStateChange({ searchPage: [] });
      const newObj = localStore.map((item) => {
        if (item.navTo === '/createLetter' && item.isRefresh) {
          item.isRefresh = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [userDefaults, localStore]);

  // This just get new update data from redux to useState
  React.useEffect(() => {
    setSetFilterValue(requestData);
  }, [requestData]);

  // get template type
  const templateTypeListSet = React.useMemo(() => {
    let fetchList = !_.isEmpty(templateTypeList)
      ? _.map(templateTypeList, (val) => ({
          id: val.codeValueID.codeValue,
          name: val.shortDescription,
        }))
      : [];
    fetchList = _.filter(fetchList, (l) => l.id !== coverTemplate);
    const optionList = !_.isEmpty(fetchList) ? _.map(fetchList, 'id') : [];
    setStateChange({ templeType: optionList });
    const list = _.union([{ id: 'ALL', name: 'All Letters' }], fetchList);
    return list;
  }, [templateTypeList]);

  // get all template list
  const templateNameListSet = React.useMemo(() => {
    let list = !_.isEmpty(templateNameList)
      ? _.map(templateNameList, (val) => ({
          id: val.templateId,
          name: val.name,
          tempversion: val.templateVersion,
        }))
      : [];
    list = _.union(list);
    list = _.orderBy(list, ['name'], ['asc']);
    setLoading(false);
    return list;
  }, [templateNameList]);

  // set default quarter value
  React.useEffect(() => {
    if (getQuarterDataValue && Object.keys(getQuarterDataValue).length > 0) {
      const str = getQuarterDataValue.data;
      const str1 = str ? handleQuarterFormate(str) : '';
      if (requestData?.quarterValue === '') {
        setRequestData({
          ...requestData,
          quarterValue: str1,
        });
      }
    }
  }, [getQuarterDataValue]);

  //  setting radioList from planList Api
  const allPlanTypeList = React.useMemo(() => {
    let planList = [];
    if (!_.isEmpty(planTypeList)) {
      planList = planTypeList.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      planList = [
        ..._.filter(planList, (l) => l.value === 'FD'),
        ..._.filter(planList, (l) => l.value !== 'FD'),
      ];
    }
    return planList;
  }, [planTypeList]);

  // get all manufacturer list
  const mfgDetailslist = React.useMemo(() => {
    setLoading(false)
    let mfgList = [];
    if (!_.isEmpty(ManufacturerDataList)) {
      mfgList = _.map(ManufacturerDataList, (val) => ({
        ...val,
        mfgId: val.mfgId,
        mfgName: val.mfgName,
      }));
    }
    mfgList = _.orderBy(mfgList, ['mfgId'], ['asc']);
    return mfgList;
  }, [ManufacturerDataList]);

  // fetch and set rebate program list
  const rebateProgramList = React.useMemo(() => {
    let list = [];

    if (!_.isEmpty(rebateProList)) {
      list = _.map(rebateProList, (val) => ({
        ...val,
        id: val.rebateProgramCd,
        name: `${val.rebateProgramCd} | ${val.shortDescr}`,
      }));
      list = list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      );
    }
    return list;
  }, [rebateProList]);

  React.useEffect(() => {
    setLoading(false);
  }, [allPlanTypeList]);

  React.useEffect(() => {
    setLoading(false);
  }, [mfgDetailslist]);

  React.useEffect(() => {
    setLoading(false);
  }, [rebateProgramList]);

  // fetch template name list
  React.useEffect(() => {
    if (filterValue?.rebateProgramCd && filterValue?.rebateProgramCd !== '-1') {
      setLoading(true);
      let templateTypeCd = extraState?.templeType;
      if (
        filterValue?.templateTypeCd &&
        filterValue?.templateTypeCd !== allTemplateTypeCd
      ) {
        templateTypeCd = [filterValue?.templateTypeCd];
      }
      if (!_.isEmpty(templateTypeCd)) {
        dispatch(
          getTemplateNameList({
            rebateProgramCd: filterValue?.rebateProgramCd,
            templateTypeCd: templateTypeCd,
          })
        );
      }
    }
  }, [
    filterValue?.rebateProgramCd,
    filterValue?.templateTypeCd,
    extraState?.templeType,
  ]);

  // fetch initialy mfg list
  React.useEffect(() => {
    if (
      filterValue?.rebateProgramCd &&
      filterValue?.rebateProgramCd !== '-1' &&
      extraState?.fetchMfg &&
      filterValue?.quarterValue
    ) {
      setLoading(true);
      setStateChange({ fetchMfg: false });
      if (filterValue.selectTypeCd === defaultSelectBy) {
        dispatch(
          getManufacturerData({
            rebateProgramCd: filterValue?.rebateProgramCd,
            qtr: filterValue?.quarterValue,
          })
        );
      }
    }
  }, [
    filterValue?.rebateProgramCd,
    filterValue?.quarterValue,
    extraState?.fetchMfg,
  ]);

  // after click on create template and before redirect detail page
  React.useEffect(() => {
    if (createLetterActive && createLetterDetail) {
      let localErr = searchErrorMessages || [];
      let errorPass = true;
      if (!_.isEmpty(localErr)) {
        localErr = [...searchErrorMessages];
        localErr = localErr.filter((item) => item.field !== somethingWentWrong);
      }
      if (!_.isEmpty(createLetterDetail)) {
        if (
          createLetterDetail.status === '001' &&
          createLetterDetail.message === 'SUCESS'
        ) {
          dispatch(updateCreateLetterSaveApi([]));
          setStateChange({
            tabs: 'Body',
            saveApiActive: false,
            letterAction: '',
            createLetterActive: false,
            saveActionType: 'Save',
          });
          dispatch(
            updateCreateLetterDetail({
              ...createLetterDetail.result,
            })
          );
          dispatch(updateInvoiceDetailsByInvoiceNum([]));
          dispatch(updateCreateLetterDetailData([]));
          errorPass = true;
          setLoading(false);
          const updateTabs =
            JSON.parse(localStorage.getItem('tabItemsData')) === null
              ? []
              : JSON.parse(localStorage.getItem('tabItemsData'));
          updateTabs.push({
            navTo: '/createLetterDetail',
            value: 'Display Letter Details',
            isFormDirty: false,
            isFormError: false,
            isFormSave: false,
            isRefresh: true,
          });
          localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
          props.history.push({ pathname: '/createLetterDetail' });
        } else {
          errorPass = false;
        }
      } else {
        setLoading(false);
      }
      if (!errorPass) {
        setLoading(false);
        localErr.push({
          field: 'somethingWentWrong',
          errorType: 'Something Went Wrong.',
          message: MNFC_NDC_ERROR_MSG,
        });
        setErrorStateChange({ searchPage: localErr });
      }
    }
  }, [createLetterActive, createLetterDetail]);

  // full screen action
  const handleFullScreenView = (view) => {
    const dataSet = {
      ...extraState.fullScreenView,
      mfgTable: view,
    };
    setStateChange({ fullScreenView: dataSet });
  };

  const filterAction = (flType, value) => {
    const newData = { ...requestData };
    let localErr = searchErrorMessages || [];
    if (!_.isEmpty(localErr)) {
      localErr = [...searchErrorMessages];
      localErr = localErr.filter((item) => item.field !== somethingWentWrong);
    }
    newData[flType] = value;

    if (flType === 'templateTypeCd') {
      newData.templateNameCd = '-1';
      newData.selectedTemplate = {};
      dispatch(dispatchTemplateNameList([]));
    }
    if (flType === 'planTypeCd') {
      newData.rebateProgramCd = '-1';
      newData.templateNameCd = '-1';
      newData.selectedTemplate = {};
      // fetchRebateProgram(newData.planTypeCd);
      dispatch(dispatchTemplateNameList([]));
    }
      if (flType === 'templateNameCd') {
      localErr = localErr.filter((item) => item.field !== flType);
      const selectedList = _.filter(
        templateNameList,
        (l) => l.templateId === value
      );
      newData.selectedTemplate = !_.isEmpty(selectedList)
        ? selectedList[0]
        : {};
    }
    if (flType === 'selectTypeCd') {
      newData.invoiceNum = '';
      // newData.quarterValue = '';
      // newData.selectedTemplate = {};
      localErr = localErr.filter(
        (item) =>
          !_.includes(
            ['rebateProgramCd', 'invoiceNum', 'quarterValue','templateNameCd'],
            item.field
          )
      );
    }
    if (flType === 'rebateProgramCd') {
      // Templates are rebate-program specific; always clear prior selection so
      // clicking a manufacturer after changing RPC prompts for Template Name.
      localErr = localErr.filter(
        (item) => item.field !== flType && item.field !== 'templateNameCd'
      );
      dispatch(dispatchTemplateNameList([]));
      newData.templateNameCd = '-1';
      newData.selectedTemplate = {};

      if (!newData.rebateProgramCd || newData.rebateProgramCd === '-1') {
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'required',
          message: REBATE_PROGRAM_REQUIRED,
        });
      }
    }
    let disabledBtnChng = false;
    if (
      ((!newData.rebateProgramCd || newData.rebateProgramCd === '-1') &&
        newData.selectTypeCd === defaultSelectBy) ||
      ((!newData.invoiceNum || newData.invoiceNum === '') &&
        newData.selectTypeCd === InvNumSelectBy)
    ) {
      disabledBtnChng = true;
    }
    setStateChange({ disabledBtn: disabledBtnChng });
    setRequestData({
      ...requestData,
      ...newData,
    });
    setErrorStateChange({ searchPage: localErr });
  };

  const onChangeFilter = (flType, val) => {
    const disData = !(val && val !== '');
    setStateChange({ disabledBtn: disData });
    setSetFilterValue({
      ...filterValue,
      [flType]: val,
    });
  };

  const handleOnblurEvent = (flType, value) => {
    const newData = { ...requestData };
    let localErr = searchErrorMessages || [];
    if (!_.isEmpty(localErr)) {
      localErr = [...searchErrorMessages];
      localErr = localErr.filter(
        (item) => !_.includes([flType, somethingWentWrong], item.field)
      );
    }
    newData[flType] = value;

    if (flType === 'invoiceNum') {
      if (!isNumeric(value)) {
        localErr.push({
          field: 'invoiceNum',
          errorType: 'invoiceinvalid',
          message: INVALID_INVOICE_NUM,
        });
      }
    }
    if (flType === 'quarterValue') {
      let msg = '';
      let errorType = '';
      if (!value) {
        msg = QUARTER_VALUE_REQUIRED;
        errorType = 'Quarter Required';
      } else if (!checkQuarterValidation(value)) {
        msg = QUARTER_FORMAT_ERROR_UC;
        errorType = 'Quarter invalid';
      }
      if (msg) {
        localErr.push({
          field: 'quarterValue',
          errorType: errorType,
          message: msg,
        });
      }
    }
    setRequestData({
      ...requestData,
      ...newData,
    });
    const disabledBtnChng = !_.isEmpty(localErr);
    setStateChange({ disabledBtn: disabledBtnChng });
    setErrorStateChange({ searchPage: localErr });
  };

  // onclicking searchButton
  const clickHandlerOnProcess = () => {
    let localErr = searchErrorMessages || [];
    if (!_.isEmpty(localErr)) {
      localErr = [...searchErrorMessages];
      localErr = localErr.filter(
        (item) =>
          !_.includes(
            ['rebateProgramCd', 'invoiceNum', 'quarterValue','templateNameCd'],
            item.field
          )
      );
    }
    let errPass = true;
    if (
      !filterValue?.rebateProgramCd ||
      filterValue?.rebateProgramCd === '-1'
    ) {
      errPass = false;
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'required',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    if (
      (!filterValue?.quarterValue || filterValue?.quarterValue === '') &&
      !checkQuarterValidation(filterValue?.quarterValue)
    ) {
      errPass = false;
      localErr.push({
        field: 'quarterValue',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
     if (
      (!filterValue?.templateNameCd || filterValue?.templateNameCd === '-1') &&
      _.isEmpty(filterValue.selectedTemplate)
    ) {
      errPass = false;
      localErr.push({
        field: 'templateNameCd',
        errorType: 'TemplateName Required',
        message: TEMPLATE_NAME_REQUIRED_ERROR,
      });
    } 

    setErrorStateChange({ searchPage: localErr });
    if (errPass) {
      setLoading(true);
      dispatch(
        getManufacturerData({
          rebateProgramCd: filterValue?.rebateProgramCd,
          qtr: filterValue?.quarterValue,
        })
      );
    }
  };

  // Redirect detail page with data
  const onClickForDetail = async (val) => {
    setLoading(true);
    const newData = { ...requestData };
    let localErr = searchErrorMessages || [];
    const request = {};
    if (!_.isEmpty(localErr)) {
      localErr = [...searchErrorMessages];
      localErr = localErr.filter(
        (item) =>
          !_.includes(
            ['templateNameCd', 'rebateProgramCd', 'invoiceNum', 'quarterValue'],
            item.field
          )
      );
    }
    let errPass = true;
    if (
      (!filterValue?.templateNameCd || filterValue?.templateNameCd === '-1') &&
      _.isEmpty(filterValue.selectedTemplate)
    ) {
      errPass = false;
      localErr.push({
        field: 'templateNameCd',
        errorType: 'TemplateName Required',
        message: TEMPLATE_NAME_REQUIRED_ERROR,
      });
    } else {
      request.templateId = filterValue.selectedTemplate.templateId;
      request.templateVersion = filterValue.selectedTemplate.templateVersion;
    }
    if (filterValue?.selectTypeCd === defaultSelectBy) {
      request.mfgId = !_.isEmpty(val) ? val.mfgId : null;
      request.quarter = filterValue?.quarterValue;
      request.rebateProgramCd = filterValue?.rebateProgramCd;
      newData.invoiceNum = val?.invoiceNum;
      if (
        !filterValue?.rebateProgramCd ||
        filterValue?.rebateProgramCd === '-1'
      ) {
        errPass = false;
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'required',
          message: REBATE_PROGRAM_REQUIRED,
        });
      }
      if (
        (!filterValue?.quarterValue || filterValue?.quarterValue === '') &&
        !checkQuarterValidation(filterValue?.quarterValue)
      ) {
        errPass = false;
        localErr.push({
          field: 'quarterValue',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }
    if (filterValue?.selectTypeCd === InvNumSelectBy) {
      request.invoiceNumber = filterValue?.invoiceNum;
      if (!isNumeric(filterValue?.invoiceNum)) {
        errPass = false;
        localErr.push({
          field: 'invoiceNum',
          errorType: 'invoiceinvalid',
          message: ENTER_NUMERIC_ONLY_ERROR('Invoice Number'),
        });
      }
    }

    if (errPass) {
      const localErr1 = [];
      newData.mfgData = val;
      request.userId = logInUser;
      let templateTypeCd = extraState?.templeType;
      if (
        filterValue?.templateTypeCd &&
        filterValue?.templateTypeCd !== allTemplateTypeCd
      ) {
        templateTypeCd = [filterValue?.templateTypeCd];
      }
      setErrorStateChange({ searchPage: [] });
      const getInvNumDetail = await dispatch(
        getInvoiceDetailsByInvoiceNum({
          invoiceNum: newData.invoiceNum,
          isReturn: true,
        })
      );
      if (!_.isEmpty(getInvNumDetail)) {
        if (getInvNumDetail?.getInvDetail.message === 'SUCESS') {
          if (getInvNumDetail?.getInvDetail.status === '001') {
            // Clear prior letter detail so createLetterActive cannot navigate
            // using a previous RPC/mfg success payload.
            dispatch(updateCreateLetterDetailData([]));
            setStateChange({ createLetterActive: true });
            dispatch(
              fetchCreateLetterDetailData({
                request: request,
                searchData: newData,
                headerDetail: {},
              })
            );
            const tempRequest = { ...request, templateTypeCd };
            dispatch(getTempTableData(tempRequest));
          } else {
            setLoading(false);
            localErr1.push({
              field: 'somethingWentWrong',
              errorType: 'Something Went Wrong.',
              message: NO_DATA_FOUND_ERROR || FAIL_PROCESSING_REQUEST,
            });
          }
        }
           if (getInvNumDetail?.getInvDetail.status === '000') {
           setLoading(false);
            localErr1.push({
              field: 'somethingWentWrong',
              errorType: 'Something Went Wrong.',
              message: INVALID_INVOICE_ERR ,
            });
          } 
        setErrorStateChange({ searchPage: localErr1 });
      }
    } else {
      setLoading(false);
      setErrorStateChange({ searchPage: localErr });
    }
  };

  const getFieldError = (key) => {
    if (searchErrorMessages?.length > 0) {
      const filterErr = _.filter(searchErrorMessages, (l) => l.field === key);
      if (!_.isEmpty(filterErr)) {
        return _.map(filterErr, (m) => m.message);
      }
    }
    return null;
  };

  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="CheckLetter-component"
    >
      <Spinner load={loading} />
      <CustomSeparator parent1="Tasks" parent2="Create Letter" />
      {searchErrorMessages?.length > 0 && !fullScreenView ? (
        <DisplayErrorMessages
          errorMessages={
            searchErrorMessages?.length > 0
              ? _.map(searchErrorMessages, (l) => l.message)
              : []
          }
        />
      ) : null}

      <div className="no-margin">
        {!fullScreenView && (
          <div className="row">
            <legend aria-hidden="true" className="d-none" />

            <div className="col-12 col-sm-12 col-md-6 frr-radio-50per-width">
              <RadioGroupComponent
                data-testid="action-redio-btn"
                id="action-radio-btn-action"
                labelName="Select by"
                required
                optionList={selectByList}
                defaultValue={
                  requestData?.filterValue?.selectTypeCd ||
                  filterValue.selectTypeCd
                }
                filterAction={(e) => filterAction('selectTypeCd', e)}
                className="log-batch-filter-radio"
              />
            </div>

            <div className="col-12 col-sm-6 col-md-3 frr-radio-100per-width">
              <SelectBoxWithoutBoxComponent
                data-testid="template-type-select-box"
                className="mt-2"
                labelName="Template Type:"
                required
                select
                selectedOne={false}
                placeholder="Please Select One"
                optionList={templateTypeListSet || []}
                defaultValue={
                  requestData?.filterValue?.templateTypeCd ||
                  filterValue?.templateTypeCd
                }
                filterAction={(e) => filterAction('templateTypeCd', e)}
              />
            </div>

            <div className="col-12 col-sm-6 col-md-3 frr-radio-100per-width">
              <SelectBoxWithoutBoxComponent
                data-testid="template-name-select-box"
                className="mt-2"
                labelName="Template Name:"
                required
                select
                selectedOne
                placeholder="Please Select One"
                optionList={templateNameListSet || []}
                defaultValue={
                  requestData?.filterValue?.templateNameCd ||
                  filterValue?.templateNameCd
                }
                filterAction={(e) => filterAction('templateNameCd', e)}
                isError={getFieldError('templateNameCd')}
              />
            </div>

            <div className="col-12">
              {filterValue.selectTypeCd === defaultSelectBy && (
                <div className="row mt-2 mb-2">
                  <div className="col-12 col-sm-12 col-md-5 frr-two-col-radio">
                    <RadioGroupComponent
                      data-testid="plan-type-data-cms-mismatch"
                      id="plan-type-id-cms-mismatch"
                      labelName="Plan Type"
                      required
                      optionList={allPlanTypeList || []}
                      defaultValue={
                        requestData?.filterValue?.planTypeCd ||
                        filterValue?.planTypeCd
                      }
                      filterAction={(e) => {
                        filterAction('planTypeCd', e);
                      }}
                      className="log-batch-filter-radio frr-checkInvoiceRadio"
                    />
                  </div>

                  <div className="col-12 col-sm-12 col-md-7 mt-2">
                    <fieldset className="custom-fieldset">
                      <legend aria-hidden="true" className="d-none" />
                      <div className="row">
                        <div className="col-12 col-sm-4 col-md-4">
                          <SelectBoxWithoutBoxComponent
                            data-testid="rebate-program-select-box"
                            className="mt-2"
                            labelName="Rebate program"
                            required
                            select
                            selectedOne
                            placeholder="Please Select One"
                            optionList={rebateProgramList || []}
                            defaultValue={
                              requestData?.filterValue?.rebateProgramCd ||
                              filterValue?.rebateProgramCd
                            }
                            filterAction={(e) =>
                              filterAction('rebateProgramCd', e)
                            }
                            isError={getFieldError('rebateProgramCd')}
                          />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                          <SelectBoxWithoutBoxComponent
                            data-testid="quarter-value-select-box"
                            className="mt-2"
                            labelName="Quarter"
                            required
                            select={false}
                            inputProps={{ maxLength: 6 }}
                            defaultValue={
                              // requestData?.filterValue?.quarterValue ||
                              filterValue?.quarterValue
                            }
                            filterAction={(e) =>
                              onChangeFilter('quarterValue', e)
                            }
                            onBlurAction={(e) =>
                              handleOnblurEvent(
                                'quarterValue',
                                autoFormateDate(e?.toUpperCase())
                              )
                            }
                            isError={getFieldError('quarterValue')}
                          />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                          <div className="mui-custom-form input-md ml-0 ml-md-2 pt-3 frr-checkinvoice-search">
                            <Button
                              className="btn btn-success btn-search"
                              data-testid="check_search_cbi"
                              disabled={disabledBtn}
                              onClick={() => {
                                clickHandlerOnProcess();
                              }}
                            >
                              <SVGComponent iconName="Icon-search" />
                              Search
                            </Button>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              )}
              {filterValue.selectTypeCd === InvNumSelectBy && (
                <div className="row">
                  <div className="col-4">
                    <SelectBoxWithoutBoxComponent
                      data-testid="INVOICE_NUM"
                      className="mt-2"
                      labelName="Invoice Number"
                      required
                      select={false}
                      inputProps={{ maxLength: 38 }}
                      defaultValue={
                        requestData?.filterValue?.invoiceNum ||
                        filterValue?.invoiceNum
                      }
                      filterAction={(e) => {
                        const rg = /^[0-9]*$/;
                        if (rg.test(e)) {
                          onChangeFilter('invoiceNum', e);
                        }
                      }}
                      onBlurAction={(e) => {
                        const rg = /^[0-9]*$/;
                        if (rg.test(e)) {
                          handleOnblurEvent('invoiceNum', e);
                        }
                      }}
                      isError={getFieldError('invoiceNum')}
                    />
                  </div>
                  <div className="col-4">
                    <div className="mui-custom-form input-md pt-3 frr-checkinvoice-search">
                      <Button
                        className="btn btn-success btn-search"
                        data-testid="check_search_cbi2"
                        disabled={disabledBtn}
                        onClick={() => onClickForDetail(null)}
                      >
                        <SVGComponent iconName="Icon-search" />
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {filterValue.selectTypeCd === defaultSelectBy && (
          <div className="row">
            <div className="col-sm-12">
              <TableGridWithFeatures
                data-testid="manufacturer-cbi-table"
                rowSelection="single"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={() =>
                  handleFullScreenView(!fullScreenView)
                }
                gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                rowData={mfgDetailslist}
                columnDefs={TableHeaderForManufacturer}
                cellClickedListener={(e) => {
                  onClickForDetail(e.data);
                }}
                exportFile
                fileName="CreateLetter-MfgList"
                helpMessage="* On Double Click of Results, system should navigate to Detail page"
                animateRows
                sideBar={false}
                singleClickEdit
                enterMovesDown
                suppressCellFocus
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default CreateLetter;
